import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Spinner } from '../../services/spinner/spinner';
import { ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ui-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
})
export class SpinnerComponent implements OnInit, OnDestroy {
  private spinnerService = inject(Spinner);
  private cdr = inject(ChangeDetectorRef);
  private sub: Subscription | null = null;

  showSpinner = false;

  get showSpinner$() {
    return this.spinnerService.spinner$;
  }

  ngOnInit(): void {
    this.sub = this.spinnerService.spinner$.subscribe((show) => {
      this.showSpinner = show;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
